import { Colors } from '@app/config/colors';
import React, { Ref, useImperativeHandle, useState, useRef, useMemo, useEffect } from 'react';
import { Container, Modal } from './styles';

export type ToastAmountRefAttrs = {
  show: (amount: number | string) => void;
};

type Props = {
  parentElement: HTMLElement | null;
  color?: string;
  tintColor?: string;
};

const SIZE = 70;

function AmountInfo(
  { color = Colors.DefaultPrimaryColor, tintColor = '#fff', parentElement }: Props,
  ref: Ref<ToastAmountRefAttrs>
) {
  const [amount, setAmount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const hideTimeout = useRef(0);
  useImperativeHandle(ref, () => {
    return {
      show: show,
    };

    function show(_amount: number | string) {
      const value = Number(_amount);
      setIsVisible(true);
      setAmount(value);
      window.clearTimeout(hideTimeout.current);
      hideTimeout.current = window.setTimeout(() => setIsVisible(false), 2000);
    }
  });

  const rect = parentElement?.getBoundingClientRect();
  const { width, height } = rect ?? {};

  const coords = useMemo(() => {
    return {
      top: Math.max((height ?? 0) / 2 - SIZE / 2, 0),
      left: width ? width / 2 - SIZE / 2 : 0,
    };
  }, [width, height]);

  return (
    <Modal
      open={isVisible}
      style={{
        position: 'absolute',
        top: coords.top,
        left: coords.left,
        zIndex: 99999,
        backgroundColor: color,
        height: SIZE,
        width: SIZE,
      }}
    >
      <span style={{ color: tintColor }}>{amount}</span>
    </Modal>
  );
}

export default React.forwardRef(AmountInfo);
